"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_icon_1 = require("@campgladiator/cgui-core.atoms.icon");
const input_module_scss_1 = __importDefault(require("@campgladiator/cgui-core.atoms.input/input.module.scss"));
const typography_module_scss_1 = __importDefault(require("@campgladiator/cgui-core.atoms.typography/typography.module.scss"));
const pin_input_module_scss_1 = __importDefault(require("./pin-input.module.scss"));
const setInputTextSizeOnInputFieldSize = (inputSize) => (inputSize === "small" ? "xsmall" : "small");
const PinFields = ({ numberOfFields, size, invalid, disabled, visible, autoFocus, pinSetter, }) => {
    const fieldsRef = (0, react_1.useRef)([]);
    const focusOnPinField = (position) => {
        const element = fieldsRef.current[position] || null;
        if (element) {
            element.focus();
            element.select();
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, [...Array(numberOfFields)].map((_, index) => {
        const [value, setValue] = (0, react_1.useState)("");
        const handleChange = (index, value) => {
            setValue(value);
            pinSetter(index, value);
        };
        const onInputKeyDown = (index, e) => {
            if (e.key === "Backspace") {
                focusOnPinField(index - 1);
                handleChange(index, "");
                e.preventDefault();
            }
            else if (e.key === value) {
                focusOnPinField(index + 1);
                e.preventDefault();
            }
        };
        const onInputChangeHandler = (index, e) => {
            const { value } = e.target;
            const isValid = value !== " " && !isNaN(+value);
            if (isValid) {
                const step = value ? 1 : -1;
                handleChange(index, value);
                focusOnPinField(index + step);
            }
        };
        return (react_1.default.createElement("input", { className: (0, classnames_1.default)(input_module_scss_1.default.input, typography_module_scss_1.default.paragraph, pin_input_module_scss_1.default.field), autoFocus: index === 0 && autoFocus, key: index, ref: (el) => (fieldsRef.current[index] = el), "data-invalid": invalid, "data-input-size": size, "data-size": setInputTextSizeOnInputFieldSize(size), inputMode: "numeric", autoComplete: "one-time-code", type: visible ? "text" : "password", pattern: "^[\\d]$", placeholder: "-", disabled: disabled, maxLength: 1, value: value, onKeyDown: (e) => onInputKeyDown(index, e), onChange: (e) => {
                onInputChangeHandler(index, e);
            } }));
    })));
};
const PinInput = react_1.default.forwardRef((_a, ref) => {
    var { className = "", size = "default", name, id, numberOfDigits, invalid = false, disabled = false, autoFocus = false, onPinChange } = _a, props = __rest(_a, ["className", "size", "name", "id", "numberOfDigits", "invalid", "disabled", "autoFocus", "onPinChange"]);
    const [pin, setPin] = (0, react_1.useState)(Array(numberOfDigits).fill(""));
    const [visible, setVisible] = (0, react_1.useState)(false);
    const setPinDigit = (position, newChar) => {
        const modifiedPin = [...pin];
        modifiedPin[position] = newChar;
        setPin(modifiedPin);
    };
    (0, react_1.useEffect)(() => {
        onPinChange && onPinChange(pin.join(""));
    }, [pin]);
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)(pin_input_module_scss_1.default.pinWrapper, className), "data-size": size }, props),
        react_1.default.createElement("input", { type: "hidden", ref: ref, name: name, id: id, value: pin.join("") }),
        react_1.default.createElement(PinFields, { numberOfFields: numberOfDigits, size: size, invalid: invalid, visible: visible, disabled: disabled, autoFocus: autoFocus, pinSetter: setPinDigit }),
        react_1.default.createElement("button", { className: pin_input_module_scss_1.default.iconBtn, type: "button", onClick: () => setVisible(!visible) },
            react_1.default.createElement(cgui_core_atoms_icon_1.Icon, { className: pin_input_module_scss_1.default.icon, name: visible ? "icon-eye-slash-line" : "icon-eye-line" }))));
});
exports.default = PinInput;
//# sourceMappingURL=pin-input.js.map